module.exports = __webpack_public_path__ + "static/media/bg.0f9492b7.jpg";